import { ProductPageMain } from './ui/product-main'
import { ProductPageHeader } from './ui/product-page-header/product-page-header'
import { ProductTabs } from './ui/product-tabs/product-tabs'

import styles from './Product.module.scss'

export const Product = () => (
	<section className={`${styles.product} Product`}>
		<ProductPageHeader />

		<ProductPageMain />

		<ProductTabs />
	</section>
)
